export var HeaderEnum;
(function (HeaderEnum) {
    HeaderEnum["PRODUCT_EQUITY"] = "/products/equity";
    HeaderEnum["FIXED_INCOME_NCD"] = "/";
    HeaderEnum["FIXED_INCOME_CORPFD"] = "/products/corporate-fd";
    HeaderEnum["FIXED_INCOME_54ACBONDS"] = "/products/capital-gains-bonds";
    HeaderEnum["ALTERNATIVE_SPMLD"] = "/products/mld";
    HeaderEnum["ALTERNATIVE_SGB"] = "/products/sgb";
    HeaderEnum["MANGED_PORTFOLIO_MF"] = "/products/mutual-funds";
    HeaderEnum["MANGED_PORTFOLIO_ETF"] = "/products/etf";
    HeaderEnum["MANGED_PORTFOLIO_SMALLCASE"] = "/";
    HeaderEnum["MANGED_PORTFOLIO_PICKRIGHT"] = "/";
    HeaderEnum["CORP_FD"] = "/";
    HeaderEnum["SGB"] = "/sgb";
    HeaderEnum["CORP_FD_PRODUCT"] = "/products/corporate-fd";
    HeaderEnum["CORP_FD_ORDERBOOK"] = "/corporate-fd/orderbook";
    HeaderEnum["SEC_MARKET_EQUITY"] = "/products/equity";
    HeaderEnum["SEC_MARKET_CURRENCY"] = "/markets/currency";
    HeaderEnum["INSURANCE_GENERAL"] = "/insurance";
    HeaderEnum["INSURANCE_LIFE"] = "/insurance";
    HeaderEnum["EQUITY"] = "/markets/equity";
    HeaderEnum["EQUITY_DRIVING_MARKET"] = "/markets/equity?sectionName=drivingMarket";
    HeaderEnum["EQUITY_STOCKUPGRADE_DOWNGRADE"] = "/markets/equity?sectionName=stocksUnderSurveillanceWrap";
    HeaderEnum["EQUITY_INSIDER_TRADING"] = "/markets/equity?sectionName=insiderTradingAndSast";
    HeaderEnum["EQUITY_EVENTCALENDAR"] = "/event-calendar";
    HeaderEnum["FUTURE"] = "/markets/futures";
    HeaderEnum["FUTURE_SPOT_COMPARATIVE"] = "/markets/futures?sectionName=futures-spotcomparative";
    HeaderEnum["FUTURE_OI_ANALYSIS"] = "/markets/futures?sectionName=futures-openinterestanalysis";
    HeaderEnum["FUTURE_SECURITY_FNO_BAN"] = "/markets/futures?sectionName=futures-securitiesinfandoban";
    HeaderEnum["OPTIONS"] = "/markets/options";
    HeaderEnum["OPTIONS_CHAIN_TOOL"] = "/option-chain-tool";
    HeaderEnum["OPTIONS_CHAIN"] = "/markets/options?sectionName=callput-tableblock";
    HeaderEnum["OPTIONS_OICHART"] = "/markets/options?sectionName=oi-charts";
    HeaderEnum["OPTIONS_ADVANCED_CHAIN"] = "/markets/options?sectionName=AdvancedOptionTools";
    HeaderEnum["MUTUAL_FUND"] = "/markets/mutualFunds";
    HeaderEnum["MUTUAL_FUND_TOPPERFORMING"] = "/markets/mutualFunds?sectionName=TopPerformingFunds";
    HeaderEnum["MUTUAL_FUND_IDEASFORINVESTMENT"] = "/markets/mutualFunds?sectionName=IdeasforInvestment";
    HeaderEnum["MUTUAL_FUND_GROWTH_CALCULATOR"] = "/markets/mutualFunds?sectionName=MfCalculator";
    HeaderEnum["MUTUAL_FUND_EXPLORE_ALL_FUNDS"] = "/markets/mutualFunds?sectionName=ExploreAllFunds";
    HeaderEnum["OTHERS_ETF"] = "/markets/etfs";
    HeaderEnum["OTHERS_OFS_BUYS_RIGHTS"] = "/corporate-action";
    HeaderEnum["SECONDARY_NCD"] = "/markets/ncds";
    HeaderEnum["OTHERS_CORP_FD"] = "/corporate-fd";
    HeaderEnum["IPO"] = "/markets/primaryMarket?sectionName=ipo";
    HeaderEnum["IPO_LIVES"] = "/markets/primaryMarket?sectionName=ipo&subSectionName=upcoming-ipos";
    HeaderEnum["IPO_TOBE_ANNOUNCED"] = "/markets/primaryMarket?sectionName=ipo&subSectionName=upcoming-ipos";
    HeaderEnum["IPO_LISTING_PERFORMANCE"] = "/markets/primaryMarket?sectionName=ipo&subSectionName=ListingPerformance";
    HeaderEnum["NCD"] = "/markets/primaryMarket/ncd-ipo";
    HeaderEnum["NCD_IPO_LIVES"] = "/markets/primaryMarket/ncd-ipo";
    HeaderEnum["NCD_IPO_UPCOMING"] = "/markets/primaryMarket/ncd-ipo";
    HeaderEnum["NFO"] = "/markets/primaryMarket/nfo";
    HeaderEnum["NFO_LIVES"] = "/markets/primaryMarket/nfo";
    HeaderEnum["NFO_UPCOMING"] = "/markets/primaryMarket/nfo";
    HeaderEnum["NFO_LISTING_PERFORMANCE"] = "/markets/primaryMarket/nfo";
    HeaderEnum["OPTION_CHAIN_INSIDER_SAST"] = "/";
    HeaderEnum["OPTION_CHAIN_MARGIN_CALCULATOR"] = "/margin-calculator";
    HeaderEnum["OPTION_CHAIN_EVENT_CALENDAR"] = "/event-calendar";
    HeaderEnum["ALERTS_TRADING_AREA"] = "/watchlist";
    HeaderEnum["ALERTS_LIVE_NEWS"] = "/live-news";
    HeaderEnum["ALERTS_ALPHA"] = "/";
    HeaderEnum["DASHBOARD_REPORT"] = "/reports/dashboard-report";
    HeaderEnum["HOLDINGS_REPORT"] = "/reports/holding";
    HeaderEnum["PROFITLOSS_REPORT"] = "/reports/profitandloss";
    HeaderEnum["TAX_REPORT"] = "/reports/tax";
    HeaderEnum["TRANSACTION_HISTORY_REPORT"] = "/reports/transaction-history";
    HeaderEnum["MARGINS_REPORT"] = "/reports/margin-report";
    HeaderEnum["LEADGER_REPORT"] = "/reports/ledger-report";
    HeaderEnum["COMMODITY"] = "/commodity/:symbol";
    HeaderEnum["ALERTS"] = "/alerts";
    HeaderEnum["PLACEORDER"] = "/";
    HeaderEnum["MARGIN_FILES"] = "/";
    HeaderEnum["AUTHORIZE_TO_SELL"] = "/authorize-sell";
    HeaderEnum["PLEDGE"] = "/epledges";
    HeaderEnum["FUND_TRANSFER"] = "/fund-transfer";
    HeaderEnum["ORDERBOOK"] = "/orderbook";
    HeaderEnum["SEE_MARGIN"] = "/";
    HeaderEnum["WATCHLIST"] = "/watchlist";
    HeaderEnum["EVOTING"] = "/";
    HeaderEnum["EDIS"] = "/edis";
    HeaderEnum["EQUITY_SIP_BOOK"] = "/";
    HeaderEnum["MF_SIP_BOOK"] = "/";
    HeaderEnum["SEARCH"] = "/search";
    HeaderEnum["POSITION"] = "/";
    HeaderEnum["CONTRACT_NOTE"] = "/reports/contract-notes-statements";
    HeaderEnum["DP_BILLS"] = "/reports/dp-bills";
    HeaderEnum["DP_INTEREST"] = "/reports/dp-interest";
    HeaderEnum["SUBSCRIPTION_HISTORY"] = "/reports/subscription-history";
})(HeaderEnum || (HeaderEnum = {}));
